import { AxiosError } from "axios";

import { tNotifications } from "@/components/atoms/notification/TNotification";

// ----------------------------------------------------------------------------

export type IAxiosError = AxiosError<{ message: string }>;

export const handleException = (error: IAxiosError) => {
  tNotifications.error({
    title: "Error",
    message:
      error.response?.data?.message ??
      "Oops! Something went wrong. Please try again",
  });
};
